export default "__VITE_ASSET__BNMRPd8L__"